"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CarouselProvider = void 0;
exports.useCarousel = useCarousel;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("../utils");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const CarouselContext = /*#__PURE__*/_react.default.createContext();
const CarouselProvider = _ref => {
  let {
    activeIndex,
    children,
    goTo,
    getCopyWithPlaceholders,
    itemLabel,
    refocus = false,
    themeTokens,
    totalItems,
    width
  } = _ref;
  const value = _react.default.useMemo(() => ({
    activeIndex,
    goTo,
    getCopyWithPlaceholders,
    itemLabel,
    refocus,
    themeTokens,
    totalItems,
    width
  }), [activeIndex, goTo, getCopyWithPlaceholders, itemLabel, refocus, totalItems, themeTokens, width]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(CarouselContext.Provider, {
    value: value,
    children: children
  });
};
exports.CarouselProvider = CarouselProvider;
function useCarousel() {
  const context = _react.default.useContext(CarouselContext);
  if (context === undefined) {
    throw new Error(`'useCarousel' must be used within a 'CarouselProvider'`);
  }
  return context;
}
CarouselProvider.propTypes = {
  children: _propTypes.default.arrayOf(_propTypes.default.element).isRequired,
  activeIndex: _propTypes.default.number.isRequired,
  goTo: _propTypes.default.func.isRequired,
  getCopyWithPlaceholders: _propTypes.default.func.isRequired,
  itemLabel: _propTypes.default.string.isRequired,
  refocus: _propTypes.default.bool,
  themeTokens: (0, _utils.getTokensPropType)('Carousel'),
  totalItems: _propTypes.default.number.isRequired,
  width: _propTypes.default.number.isRequired
};